import React from 'react';
import './style.css';

export const session = {
    participants: [
      {
        id: 1,
        name: "Julio",
        email: "",
      },
      {
        id: 2,
        name: "Martin",
        email: "martinkunbrc@hotmail.com",
      },
      {
        id: 3,
        name: "Maria",
        email: "",
      },
    ],
    expenses: [
      {
        title: "Coffee meet",
        description: "2 coffees, 1 tea, 1 cherry pie",
        payer_user_id: 2,
        payers: [1, 2],
        amount: 3500.0,
        expense_date: "2022-05-16",
      },
    ],
  };

class ExpensesSplit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            session: session
        };
    }

    render() {
        return (
            <div className={'expensesContainer'}>
                <div>
                    <p>Working On It</p>
                </div>
            </div>
        );
    }

}

export default ExpensesSplit;


// WEBPACK FOOTER //
// ./src/screens/expensesSplit/index.js